

























































import {
  defineComponent,
  computed,
  useRoute,
  useContext
} from '@nuxtjs/composition-api';
import { useTranslations, useReview } from '@vue-storefront/novulo';
import useWindowResize from '@/hooks/useResizeWindow';
import useWriteReviewDrawerOpener from '~/hooks/useWriteReviewDrawerOpener';
import usePromotionsDrawer from '~/hooks/usePromotionsDrawer';

type reviewsDataType = {
  score: number;
  reviewsCount: number;
  large: boolean;
  writeReviewLink: string;
  hasScore: boolean;
  productId: number;
};

export default defineComponent({
  props: {
    skuNumber: {
      type: String,
      required: true,
      default: ''
    },
    media: {
      type: String,
      required: false,
      default: ''
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    ratingNumber: {
      type: Number,
      required: false,
      default: 0
    },
    reviewsCount: {
      type: Number,
      required: false,
      default: 0
    },
    superDeal: {
      type: Object,
      required: false,
      default: null
    },
    recommendationPercentage: {
      type: Number,
      required: false,
      default: 0
    },
    isOccasion: {
      type: Boolean,
      required: false,
      default: false
    },
    productId: {
      type: Number,
      required: false,
      default: 0
    },
    brand: {
      type: String,
      required: false,
      default: ''
    }
  },
  setup(props) {
    const { getWriteReviewEssentials } = useReview();
    const { toggleWriteReviewDrawer } = useWriteReviewDrawerOpener();
    const { translate } = useTranslations();
    const { openPromotionsDrawer } = usePromotionsDrawer();

    const { i18n } = useContext();

    const { isDesktop } = useWindowResize();
    const isMedia = computed(() => Boolean(props.media));
    const articleNumberSeparator = computed(() =>
      i18n.locale === 'fr' ? ' :' : ':'
    );
    const route = useRoute();

    const reviewsData = computed<reviewsDataType>(() => ({
      score: props.ratingNumber || 0,
      reviewsCount: props.reviewsCount,
      large: false,
      writeReviewLink: 'review' + route?.value?.fullPath,
      hasScore: false,
      productId: props.productId
    }));

    const scrollToElement = (elementSelector: string) => {
      const element = document.querySelector(elementSelector);
      if (element) {
        const yOffset = -200;
        const scrollPosition =
          element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: scrollPosition, behavior: 'smooth' });
      }
    };

    const formatRating = (rating: number) => {
      const locale = i18n.locale;
      return rating.toLocaleString(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    };

    const openWriteReviewDrawer = () => {
      getWriteReviewEssentials(props.productId);
      toggleWriteReviewDrawer(true);
    };

    const handleReviewsBarClick = () => {
      if (reviewsData.value.reviewsCount > 0) {
        scrollToElement('#reviewsSection');
      } else {
        openWriteReviewDrawer();
      }
    };

    return {
      isDesktop,
      isMedia,
      reviewsData,
      handleReviewsBarClick,
      openPromotionsDrawer,
      translate,
      formatRating,
      articleNumberSeparator
    };
  }
});
